import React, { useContext } from 'react';
import SectionBlock from './SectionBlock';
import { IconCalendarL } from '../../../icons';
import { MatchingDialogContext } from '../configs';
import {
    resolveMinimumAgeDescriptionHorse,
    resolveMinimumAgeDescriptionRider,
    showSection,
} from '../utils';
import { trimDisplayNameLastWord } from '../../../util/text';

const SectionMinimumAge = () => {
    const {
        scoreData,
        categorySelected,
        currentPageListing,
        horseListing,
        riderListing,
    } = useContext(MatchingDialogContext);
    const minimumAgeScoreNum = scoreData?.minimumAgeScore;

    if (typeof minimumAgeScoreNum !== 'number') return null;

    const minimumAgeScore = { maxScore: 100, total: minimumAgeScoreNum };

    const { isHighScore, isLowScore, isMidScore, shouldBeShown } = showSection({
        categorySelected,
        ...minimumAgeScore,
    });

    if (!shouldBeShown) return null;

    const { title } = currentPageListing?.attributes || {};

    const isHorseListing = horseListing.id.uuid === currentPageListing.id.uuid;

    const descriptionResolver = isHorseListing
        ? resolveMinimumAgeDescriptionRider
        : resolveMinimumAgeDescriptionHorse;

    const description = descriptionResolver({
        isHighScore,
        isLowScore,
        isMidScore,
        title: !isHorseListing ? trimDisplayNameLastWord(title) : title,
        age: riderListing?.attributes?.publicData?.age,
        minimumAge: horseListing?.attributes?.publicData?.minimumAge,
    });

    return (
        <SectionBlock scoreData={scoreData}>
            <SectionBlock.Header>
                <IconCalendarL />
                <span>Alter</span>
            </SectionBlock.Header>
            <SectionBlock.ScoreBadge sectionScoreData={minimumAgeScore} />
            <SectionBlock.Description>{description}</SectionBlock.Description>
        </SectionBlock>
    );
};

export default SectionMinimumAge;
